import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-diagnosis-node-unfinished",
  "use": "app-icon-diagnosis-node-unfinished-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-diagnosis-node-unfinished\"><path d=\"M8 0a8 8 0 110 16A8 8 0 018 0zm4 7H4v2h8V7z\" fill=\"#9EA4B3\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol